import santaHatImg from "./assets/canada-hardware-logo-santa-hat.svg";
import gpuImg from "./assets/evga-3090.webp";
import cpuImg from "./assets/ryzen-zen-4.webp";

export const sliderItems = [
  {
    id: 0,
    img: "https://images10.newegg.com/BizIntell/item/24/012/24-012-040/features-layout-1_062520.png",
    alt: "A gaming monitor on display",
    title: "Christmas Sale",
    description:
      "Best 1440p 240hz displays on the market. GIGABYTE M27Q-PRO 27 inch Gaming Monitor 30% off!",
    bg: "f5fafd",
  },
  {
    id: 1,
    img: cpuImg,
    alt: "AMD Ryzen 7 5000 Series CPU",
    title: "Holiday Bundles on Computer Parts",
    description:
      "2 FREE VIDEO GAMES INCLUDED WITH EACH PURCHASE OF THE RYZEN ZEN 4 GENERATION OF CPUS",
    bg: "fcf1ed",
  },
  {
    id: 2,
    img: gpuImg,
    alt: "EDVGA XC3 Ultra GeForce RTX 3090 GPU",
    title: "GPUs finally in stock",
    description: "GREAT VALUE FOR LAST GEN OF GPUS GOING UNDER MRSP!",
    bg: "e2fee2",
  },
];

export const categories = [
  {
    id: 0,
    img: "https://static.techspot.com/articles-info/2486/images/2022-06-21-image-6.jpg",
    title: "A HOLIDAY FEAST FOR THE EYES",
    alt: "GPU on desk with War Machine Action Figure",
    cat: "GPU",
  },
  {
    id: 1,
    img: "https://static.techspot.com/articles-info/2444/images/2022-04-05-image-6.jpg",
    title: "NEW YEAR'S (HIGH) RESOLUTIONS",
    alt: "An MSI computer monitor with a cityscape desktop image",
    cat: "Monitor",
  },
  {
    id: 2,
    img: "https://static.techspot.com/articles-info/2567/images/2022-11-16-image-2.jpg",
    title: "CPUS FASTER THAN SANTA'S SLEIGH",
    alt: "Lego Spider-Pig from Into the Spider-Verse drives a Spider-Man themed Lego car with an AMD CPU in it",
    cat: "CPU",
  },
];

export const santaHat = [
  {
    id: 0,
    img: santaHatImg,
    alt: "Canada Hardware logo with a Santa hat on it",
  },
];
